/* eslint-disable */
/* tslint:disable */

import {
	CategorizationTemplateCreateRequest, CategorizationTemplateListResponse,
	InapplicabilityReasonSimpleResponse,
} from "./data-contracts";
import {ContentType, HttpClient, RequestParams} from "./http-client";

class InapplicabilityReasons<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * @description для экрана 10.2.1
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получение списка причин некатегорируемости
	 * @request GET:/inapplicability_reasons
	 * @secure
	 */
	inapplicabilityReasonsList = (params: RequestParams = {}) =>
		this.request<InapplicabilityReasonSimpleResponse[], void>({
			path: `/inapplicability_reasons`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Шаблоны категоризации
	 * @summary Список шаблонов категоризации
	 * @request GET:/kii/object/template
	 * @secure
	 */
	categorizationTemplateList = (
		params: RequestParams = {},
	) =>
		this.request<CategorizationTemplateListResponse[], void>({
			path: `/kii/object/template`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Шаблоны категоризации
	 * @summary Применить шаблон категоризации к объектам организации
	 * @request POST:/kii/object/template/{id}
	 * @secure
	 */
	categorizationTemplateApply = (body:{objects:number[]},id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/kii/object/template/${id}`,
			method: "POST",
			body,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Шаблоны категоризации
	 * @summary Добавление шаблона категоризацииз
	 * @request POST:/kii/object/{id}/template
	 * @secure
	 */
	categorizationTemplateCreate = (
		id: number,
		data: CategorizationTemplateCreateRequest,
		params: RequestParams = {},
	) =>
		this.request<void, void | String[]>({
			path: `/kii/object/${id}/template`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
}
export const inapplicabilityReasonsAPI = new InapplicabilityReasons();
